"use client";
import {
  tooltip_default
} from "./chunk-6LIX6LVT.mjs";
import {
  useTooltip
} from "./chunk-JXI6O2DW.mjs";
export {
  tooltip_default as Tooltip,
  useTooltip
};
